// extracted by mini-css-extract-plugin
export default {"root":"TourManager_root--ZR1","onboardingOpen":"TourManager_onboardingOpen--Atn"};